"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHistoryResponseSchema = exports.UserHistoryEntrySchema = void 0;
const zod_1 = require("zod");
/** `result` holds the chosen AddressLocation as a JSON string. */
exports.UserHistoryEntrySchema = zod_1.z.object({
    typedUserString: zod_1.z.string(),
    result: zod_1.z.string(),
});
exports.UserHistoryResponseSchema = zod_1.z.object({
    history: zod_1.z.array(exports.UserHistoryEntrySchema),
});
//# sourceMappingURL=user-history.js.map